import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { SeoService } from '../../../../services/seo/seo.service';

@Component({
  selector: 'wil-client-link-not-found',
  standalone: true,
  imports: [],
  templateUrl: './client-link-not-found.component.html',
  styleUrl: './client-link-not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientLinkNotFoundComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly seoService = inject(SeoService);

  ngOnInit(): void {
    const routeData = this.route.snapshot.data;
    this.seoService.updateSeoTags({
      title: routeData['title'],
      description: routeData['description'],
    });
  }
}
